import { createAnimation, iosTransitionAnimation, isPlatform, mdTransitionAnimation } from "@ionic/vue";

const BACK_DURATION = 280;
const FORWARD_DURATION = 300;
const IOS_EASING = "cubic-bezier(0.32,0.72,0,1)";

export function appNavAnimation(baseEl, opts = {}) {
    const direction = opts.direction || "forward";
    const duration = direction === "back" ? BACK_DURATION : FORWARD_DURATION;
    const animationOpts = {
        ...opts,
        duration: opts.duration ?? duration,
    };

    if (direction !== "back" && opts.enteringEl && opts.leavingEl) {
        const rootAnimation = createAnimation()
            .duration(animationOpts.duration)
            .easing(IOS_EASING)
            .beforeRemoveClass("ion-page-invisible");

        const enteringAnimation = createAnimation()
            .addElement(opts.enteringEl)
            .fromTo("transform", "translateX(99.5%)", "translateX(0%)");

        const leavingAnimation = createAnimation()
            .addElement(opts.leavingEl)
            .fromTo("transform", "translateX(0%)", "translateX(-12%)");

        rootAnimation.addAnimation([enteringAnimation, leavingAnimation]);
        if (baseEl) {
            rootAnimation.addAnimation(createAnimation().addElement(baseEl));
        }
        return rootAnimation;
    }

    const mode = opts.mode || (isPlatform("ios") ? "ios" : "md");
    const animationBuilder = mode === "ios" ? iosTransitionAnimation : mdTransitionAnimation;
    return animationBuilder(baseEl, animationOpts);
}
